module.exports = __webpack_public_path__ + "static/media/1656587765_31-illustration_png.4879551e.png";